import { Priority, TicketType, TicketStatus } from "@/common/enum";
import ZenDeskTicketCommentModel from "./ZenDeskTicketCommentModel";

export default class ZenDeskTicketModel {
  public id!: number;
  public companyId!: number;
  public description!: string;
  public subject!: string;
  public priority!: Priority;
  public type!: TicketType;
  public status!: TicketStatus;
  public requesterEmail!: string;
  public requesterName!: string;
  public requesterId!: number;
  public assigneeId!: number;
  public createdAt!: Date;
  public updatedAt!: Date;
  public comments!: ZenDeskTicketCommentModel[];
  public companyName!: string;
}

export class UpdateZenDeskTicketModel extends ZenDeskTicketModel {
  public comment!: ZenDeskTicketCommentModel;
}
